export function cssTimeToMilliseconds(timeString) {
  const num = parseFloat(timeString, 10);
  let unit = timeString.match(/m?s/);
  let milliseconds;

  if (unit) {
    unit = unit[0];
  }

  switch (unit) {
    case 's': // seconds
      milliseconds = num * 1000;
      break;
    case 'ms': // milliseconds
      milliseconds = num;
      break;
    default:
      milliseconds = 0;
      break;
  }

  return milliseconds;
}

// handle auto submit... used on news archive page
// CSP blocks inline scripts so need to move this 
// functionality into a javascript file
// replaces the onchange handler
// onchange="this.form.submit()"
document.addEventListener('change', (e) => {
  if (e.target.matches('select.wl-js-auto-submit')) {
    if (e.target.form) e.target.form.submit();
  }
});
